var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('file-pond',{ref:"pond",attrs:{"name":"test","label-idle":"Drop files here or <span class='filepond--label-action'>Browse</span>","allow-multiple":"true","files":_vm.myFiles},on:{"init":_vm.handleFilePondInit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }